import { z } from 'zod'
import { Pagination } from '../helper'

export const templateSectionTypeEnum = z.enum([
  'Header',
  'DeviceSummaryTable',
  'MeasurementsTable',
  'StatisticsTable',
  'LineChart',
  'BarChart',
  'TextBlock',
  'PageBreak',
  'Footer',
])

export const templateSectionSchema = z.object({
  id: z.string(),
  sectionType: z.string().nullable(),
  orderNo: z.number(),
  title: z.string().nullable(),
  configuration: z.string().nullable(),
})

export const templateChapterSchema = z.object({
  id: z.string(),
  orderNo: z.number(),
  title: z.string().nullable(),
  sections: z.array(templateSectionSchema),
})

export const reportTemplateListItemSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  description: z.string().nullable(),
  attachCsv: z.boolean(),
  attachPdf: z.boolean(),
  chapterCount: z.number(),
  createdAt: z.string(),
})

export const reportTemplateDetailsSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  description: z.string().nullable(),
  attachCsv: z.boolean(),
  attachPdf: z.boolean(),
  createdAt: z.string(),
  createdBy: z.string(),
  lastModifiedAt: z.string().nullable(),
  lastModifiedBy: z.string().nullable(),
  chapters: z.array(templateChapterSchema).nullable(),
})

export type TTemplateSectionType = z.infer<typeof templateSectionTypeEnum>
export type TTemplateSection = z.infer<typeof templateSectionSchema>
export type TTemplateChapter = z.infer<typeof templateChapterSchema>
export type TReportTemplateListItem = z.infer<
  typeof reportTemplateListItemSchema
>
export type TReportTemplateDetails = z.infer<typeof reportTemplateDetailsSchema>
export type TReportTemplateList = Pagination<TReportTemplateListItem>
